/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './Checkbox.scss'
import React from 'react'

function Checkbox(props) {
  const clsName = 'checkbox' + (props.disabled ? ' checkbox-disabled' : '')
  const onClick = props.disabled ? () => {} : props.onClick
  let boxCls = 'checkbox__box'
  boxCls += props.isSelected ? ' checkbox__box-selected' : ''
  boxCls += props.disabled ? ' checkbox__box-disabled' : ''

  return (
    <div className={`${clsName}`} id={props.id}>
      <div className={boxCls} onClick={onClick} />
      <div className="checkbox__label" onClick={onClick}>
        {' '}
        {props.label}{' '}
      </div>
    </div>
  )
}

export default Checkbox
